import type { LinkProps } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import { MenuVariant, SportsLink } from '@swf/sports/components';

import styles from './MenuLink.scss';

export type Props = {
  url?: string;
  variant?: MenuVariant;
  isActive?: boolean;
  hasPadding?: boolean;
} & Omit<LinkProps, 'isActive'>;

const MenuLink: React.FC<Props> = ({
  children,
  url,
  variant,
  isActive,
  hasPadding = true,
  ...linkProps
}) => (
  <li
    className={classNames(styles.listItem, {
      [styles.variantDark]: variant === MenuVariant.DARK
    })}
  >
    <SportsLink
      isActive={typeof isActive === 'boolean' ? () => !!isActive : undefined}
      className={classNames(styles.link, {
        [styles.variantDark]: variant === MenuVariant.DARK,
        [styles.noPadding]: !hasPadding
      })}
      href={url}
      {...linkProps}
    >
      {children}
    </SportsLink>
  </li>
);

export default MenuLink;
